module.exports = __webpack_public_path__ + "6962439d637c0bb679a9430b68609ce8.png";